module.exports = __webpack_public_path__ + "eb473c5d803c9005ef28b85fad507ebb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tab-bg-green.png
// module id = 548
// module chunks = 0